<template>
  <footer class="auth-footer">
    <slot>
      Sistema de Gestión de Vacaciones Útiles - UNMSM &copy; {{ currentYear }}
    </slot>
  </footer>
</template>

<script setup lang="ts">
import { useAuthFooter } from './AuthFooter'

const { currentYear } = useAuthFooter()
</script>

<style scoped lang="scss" src="./AuthFooter.scss" />
